import { render, staticRenderFns } from "./Forp2.vue?vue&type=template&id=31ccb626&scoped=true"
import script from "./Forp2.vue?vue&type=script&lang=js"
export * from "./Forp2.vue?vue&type=script&lang=js"
import style0 from "./Forp2.vue?vue&type=style&index=0&id=31ccb626&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ccb626",
  null
  
)

export default component.exports